import React, { useMemo, useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import {
  Building2,
  LayoutGrid,
  UserRound,
  Wallet, 
} from "lucide-react";


import company1 from "../../assets/img/company1.svg";
import company2 from "../../assets/img/company2.svg";
import TransactionHistory from "./TransactionHistory";
import WalletBalanceCard from "./WalletBalanceCard";
import { useWallet } from "../../context/WalletContext";




const MyWallet = () => {

  const { walletData } = useWallet ();

  
  const searchTabs = [
    {
      id: "walletBalanceCard",
      label: "Wallet",
      icon: Wallet,
    },
    {
      id: "transactionHistory",
      label: "Transaction History",
      icon: Wallet,
    },
    
  ];


  const [activeTab, setActiveTab] = useState("walletBalanceCard");
  const isActive = true; // API se mila

  const activeTabConfig = useMemo(
    () => searchTabs.find((tab) => tab.id === activeTab) ?? searchTabs[0],
    [activeTab]
  );

  // const activeResults = tabContent[activeTab] ?? [];

  const { setSearchActiveTab } = useOutletContext();

  useEffect(() => {
    console.log("Active Tab:", activeTab);
    setSearchActiveTab(activeTab);
  }, [activeTab]);

 
   

  return (
    <div className="dashboard-search-results">     

      <div className="row g-3">


        <div className="col-12">
          <div className="sr-shell-card p-3 p-md-4">
              <h1 className="sr-page-title">
                  My Wallet
              </h1>
              <p className="sr-page-subtitle">
                Earn coins by completing surveys and redeem for exciting rewards.
              </p>
          </div>
        </div>



        <div className="col-12">
          <div className="sr-shell-card p-3 p-md-4">
              <div className="sr-tabs-shell px-3">
                <div className="d-flex flex-nowrap sr-tabs-wrapper tw-gap-10 sm:tw-gap-3">
                    {searchTabs.map((tab) => {
                      const Icon = tab.icon;

                      return (
                        <div
                          key={tab.id}
                          className="d-flex flex-shrink-0 sm:tw-flex-1"
                        >
                          <button
                            type="button"
                            className={`sr-tab-btn sm:tw-w-full ${
                              activeTab === tab.id ? "active" : ""
                            }`}
                            onClick={() => setActiveTab(tab.id)}
                          >
                            <Icon size={14} />
                            <span>{tab.label}</span>
                          </button>
                        </div>
                      );
                    })}
                </div>
            </div>
          </div>
        </div>

        
      
       <div className="col-12 g-3">

          {activeTab === "walletBalanceCard" && (
            <>
              <WalletBalanceCard />
            </>
          )}

          {activeTab === "transactionHistory" && (            
             <>
              <TransactionHistory />
            </>
          )}

         

        </div>



      </div>
    </div>
  );
};

export default MyWallet;
